import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { ISequence } from '../sequence.interface';
import { SequenceCoreService } from '../sequence-core.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sequence-selector',
  templateUrl: './sequence-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SequenceSelectorComponent),
    },
  ],
})
export class SequenceSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Input()
  label = 'Sequence';

  @Output() itemSelected = new EventEmitter<ISequence>();

  ctrl: FormControl = new FormControl();

  constructor(public sequenceCoreService: SequenceCoreService) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        const sequence = this.sequenceCoreService.getSequence(value);
        this.itemSelected.emit(sequence);
        if (value) {
          this.onChange(value);
        } else {
          this.onChange(null);
        }
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange: any = (): void => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.sequenceCoreService.refresh(true);
  }
}
